var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWallet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.26 13.4h3.11v1.444h-3.11V13.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m24.346 9.676-.039 12.34H.36V5.302h.032a2.718 2.718 0 0 1-.038-.453C.354 3.279 1.697 2 3.344 2h18.039v4.248h2.97V9.67l-.007.006Zm-1.514-1.979v1.828l-.034 11.048H1.876V7.329c.435.234.936.368 1.47.368h19.487ZM3.344 3.45c-.813 0-1.475.63-1.475 1.405S2.53 6.26 3.344 6.26h16.517V3.45H3.344Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Wallet.ab34548026530ee4e965ff33b4103c60.svg";